module.exports = __webpack_public_path__ + "img/illustration-register-v2-dark.2649ee89.jpg";